import * as i18nData from '@mc-alberta/i18n-data'
import { i18nAdapter } from '@mc-alberta/supernova-scripts'
import Vue from 'vue'
import { DEFAULT_LANGUAGE } from '@/constants'
import content from '@/content'

let i18nSingleton

const i18nOptions = {
  locale: DEFAULT_LANGUAGE,
  fallbackLocale: i18nData.getFallbackConfig(DEFAULT_LANGUAGE),
  messages: content,
  silentTranslationWarn: true
}

export function getI18nSingleton() {
  if (!i18nSingleton) {
    Vue.use(i18nAdapter, i18nOptions)
    i18nSingleton = i18nAdapter.getI18nSingleton()
  }

  return i18nSingleton
}
